import React from "react";
import { Helmet } from "react-helmet-async";

import Navbardesign from "../Components/Navbar";
import AboutMithaHomes from "../Components/Aboutpage/Aboutpageconcepts";
import ProjectListingPage from "../Components/Aboutpage/ProjectDetailshome";
import Footer from "../Components/FooterDomain/Footerdata";
import ContactBar from "../Components/Fixedpossion/Fixedposion";

const AboutPage = () => {
  return (
    <>
      {/* ================= SEO META ================= */}
      <Helmet>
        <title>About Us | Mitha Construction & Development – Trichy</title>

        <meta
          name="description"
          content="Learn more about Mitha Construction & Development, a trusted construction company in Trichy delivering quality residential and commercial projects with integrity and innovation."
        />

        <meta
          name="keywords"
          content="About Mitha Construction, construction company Trichy, builders in Trichy, Mitha Homes about us"
        />

        <meta
          property="og:title"
          content="About Mitha Construction & Development"
        />
        <meta
          property="og:description"
          content="Discover the story, values, and expertise behind Mitha Construction & Development – one of the most trusted builders in Trichy."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.mithahomes.com/about" />
        <meta
          property="og:image"
          content="https://dev.mithahomes.com/backend/uploads/about_page_banner.jpg"
        />
      </Helmet>

      <Navbardesign />

      <br />
      <br />
      <br />
      <br />

      {/* Breadcrumb Section - Centered */}
      <div>
        <nav className="breadcrumb-nav">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li>About</li>
          </ul>
        </nav>
      </div>

      <AboutMithaHomes />
      {/* <ProjectListingPage /> */}

      <Footer />
      <br />
      <br />
      <br />
      <ContactBar />

      {/* ================= CSS Styles ================= */}
      <style>
        {`
          .breadcrumb-nav {
            background-color: #e25e27;
            padding: 15px 20px;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .breadcrumb-nav ul {
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .breadcrumb-nav ul li {
            font-family: Roboto, sans-serif;
            font-size: 14px;
            font-weight: 600;
            color: #ffffff;
            margin-right: 15px;
            display: flex;
            align-items: center;
          }

          .breadcrumb-nav ul li a {
            color: #f7e6a7;
            text-decoration: none;
          }

          .breadcrumb-nav ul li:first-child:after {
            content: "❯";
            color: #f7e6a7;
            margin-left: 15px;
            font-weight: 400;
          }

          .page-title {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 20px 0;
            text-align: center;
            width: 100%;
          }

          @media (max-width: 768px) {
            .page-title {
              font-size: 1.8rem;
            }
          }

          @media (max-width: 480px) {
            .breadcrumb-nav ul li {
              font-size: 1rem;
            }

            .page-title {
              font-size: 1rem;
            }

            .breadcrumb-nav {
              padding: 10px;
            }

            .breadcrumb-nav ul li {
              margin-right: 10px;
            }

            .breadcrumb-nav ul li:first-child:after {
              margin-left: 10px;
            }
          }

          @media (max-width: 360px) {
            .breadcrumb-nav ul {
              flex-direction: column;
              gap: 5px;
            }

            .breadcrumb-nav ul li:first-child:after {
              display: none;
            }
          }
        `}
      </style>
    </>
  );
};

export default AboutPage;
